module.exports = __webpack_public_path__ + "static/img/modeling4.855bc13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modeling4.png
// module id = gaJi
// module chunks = 2